import { render, staticRenderFns } from "./HistoryIntegration.vue?vue&type=template&id=006f703c&scoped=true"
import script from "./HistoryIntegration.vue?vue&type=script&lang=js"
export * from "./HistoryIntegration.vue?vue&type=script&lang=js"
import style0 from "./HistoryIntegration.vue?vue&type=style&index=0&id=006f703c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006f703c",
  null
  
)

export default component.exports